export const contactsData = {
    email: 'kanav0099@gmail.com',
    phone: '+917988499067',
    address: 'Akhnoor, Jammu, India - 181201 ',

    sheetAPI: ''
}